<template>
    <div>
        <div v-if="this.$store.state.game === 'starting'">
            <input class="playerName" v-model="player.name">
            <slot></slot>
        </div>
        <div v-else-if="this.$store.state.game === 'playing'" @click="show = !show">
            <span class="playerName">{{player.name}} ({{player.getCurrentScore(this.$store.state.baseScore)}})</span>
            <font-awesome-icon class="caret" v-if="player.active || this.show" icon="caret-down"></font-awesome-icon>
            <font-awesome-icon class="caret" v-else icon="caret-up"></font-awesome-icon>
            <ul v-if="player.active || this.show">
                <li v-for="(points, turn) in player.thrown">
                    {{score(turn)}} <span v-if="turn > 0">
                        ({{points}})
                    </span>
                </li>
            </ul>
            <div v-if="player.active">
                <input v-model="dinglebobs" type="number">
                <button class="button button--small" @click="turn(dinglebobs)"><font-awesome-icon icon="save"></font-awesome-icon></button>
            </div>
        </div>
        <div v-else-if="this.$store.state.game === 'completed' && player.active" @click="show = !show">
            {{player.name}} <font-awesome-icon icon="trophy"></font-awesome-icon>
            <font-awesome-icon class="caret" v-if="player.active || this.show" icon="caret-down"></font-awesome-icon>
            <font-awesome-icon class="caret" v-else icon="caret-up"></font-awesome-icon>
        </div>
        <div v-else >
            {{player.name}} ({{player.getCurrentScore(this.$store.state.baseScore)}})
        </div>
    </div>
</template>

<script>
    import Player from "../Classes/Player";

    export default {
        name: "PlayerSettings",
        props: {
            player: Player,
            nextPlayer: Player
        },
        data(){
            return {
                dinglebobs: 0,
                show: true
            }
        },
        methods: {
            score(turn) {
                return this.player.getScoreForTurn(this.$store.state.baseScore, turn);
            },
            turn(score) {
                let newScore = this.player.getCurrentScore(this.$store.state.baseScore) - score;
                console.log(newScore);

                this.dinglebobs = 0;

                if(newScore > 0){

                    this.player.active = false;
                    this.nextPlayer.active = true;

                    this.player.throw(score);
                    return;
                }

                if(newScore === 0){
                    this.$store.state.game = "completed";
                }

                if(this.$store.state.settings.mustEndOnExactlyZero){
                    return;
                }

                this.player.throw(score);
                EventBus.$emit('sort-players');
                this.$store.state.game = "completed";
            },
        }
    }
</script>

<style scoped>

</style>